import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.7085 1.9413a.798.798 0 0 0-.7152-.4413H8.918a.798.798 0 0 0-.7151.4413L7.0225 4.3208H3v1.5951h1.1352v15.8479c0 .4405.3571.7976.7976.7976h13.0484a.7976.7976 0 0 0 .7976-.7976V5.9159h1.1352V4.3208h-4.0225zM9.4142 3.0941h4.089l.6141 1.2256H8.8001zm-.5546 16.1155H7.2644v-10.98h1.5952zm3.3953 0h-1.5952v-10.98h1.5952zm3.3946 0h-1.5952v-10.98h1.5952z",
    clipRule: "evenodd"
}), "StatusDeleted", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
